const unicodeScripts = [
	'Adlam',
	'Aghwan',
	'Ahom',
	'Anatolian_Hieroglyphs',
	'Arabic',
	'Armenian',
	'Avestan',
	'Balinese',
	'Bamum',
	'Bassa_Vah',
	'Batak',
	'Bengali',
	'Bhaiksuki',
	'Bopomofo',
	'Brahmi',
	'Braille',
	'Buginese',
	'Buhid',
	'Canadian_Aboriginal',
	'Carian',
	'Caucasian_Albanian',
	'Chakma',
	'Cham',
	'Cherokee',
	'Chorasmian',
	'Common',
	'Coptic',
	'Cuneiform',
	'Cypriot',
	'Cypro_Minoan',
	'Cyrillic',
	'Deseret',
	'Devanagari',
	'Dives_Akuru',
	'Dogra',
	'Duployan',
	'Egyptian_Hieroglyphs',
	'Elbasan',
	'Elymaic',
	'Ethiopic',
	'Garay',
	'Georgian',
	'Glagolitic',
	'Gothic',
	'Grantha',
	'Greek',
	'Gujarati',
	'Gunjala_Gondi',
	'Gurmukhi',
	'Han',
	'Hangul',
	'Hanifi_Rohingya',
	'Hanunoo',
	'Hatran',
	'Hebrew',
	'Hiragana',
	'Imperial_Aramaic',
	'Inherited',
	'Inscriptional_Pahlavi',
	'Inscriptional_Parthian',
	'Javanese',
	'Kaithi',
	'Kannada',
	'Katakana',
	'Kawi',
	'Kayah_Li',
	'Kharoshthi',
	'Khitan_Small_Script',
	'Khmer',
	'Khojki',
	'Khudawadi',
	'Lao',
	'Latin',
	'Lepcha',
	'Limbu',
	'Linear_A',
	'Linear_B',
	'Lisu',
	'Lycian',
	'Lydian',
	'Mahajani',
	'Makasar',
	'Malayalam',
	'Mandaic',
	'Manichaean',
	'Marchen',
	'Masaram_Gondi',
	'Medefaidrin',
	'Meetei_Mayek',
	'Mende_Kikakui',
	'Meroitic_Cursive',
	'Meroitic_Hieroglyphs',
	'Miao',
	'Modi',
	'Mongolian',
	'Mro',
	'Multani',
	'Myanmar',
	'Nabataean',
	'Nag_Mundari',
	'Nandinagari',
	'New_Tai_Lue',
	'Newa',
	'Nko',
	'Nushu',
	'Nyiakeng_Puachue_Hmong',
	'Ogham',
	'Ol_Chiki',
	'Old_Hungarian',
	'Old_Italic',
	'Old_North_Arabian',
	'Old_Permic',
	'Old_Persian',
	'Old_Sogdian',
	'Old_South_Arabian',
	'Old_Turkic',
	'Old_Uyghur',
	'Oriya',
	'Osage',
	'Osmanya',
	'Pahawh_Hmong',
	'Palmyrene',
	'Pau_Cin_Hau',
	'Phags_Pa',
	'Phoenician',
	'Pollard',
	'Psalter_Pahlavi',
	'Rejang',
	'Runic',
	'Samaritan',
	'Saurashtra',
	'Sharada',
	'Shavian',
	'Siddham',
	'SignWriting',
	'Sinhala',
	'Sogdian',
	'Sora_Sompeng',
	'Soyombo',
	'Sundanese',
	'Syloti_Nagri',
	'Syriac',
	'Tagalog',
	'Tagbanwa',
	'Tai_Le',
	'Tai_Tham',
	'Tai_Viet',
	'Takri',
	'Tamil',
	'Tangsa',
	'Tangut',
	'Telugu',
	'Thaana',
	'Thai',
	'Tibetan',
	'Tifinagh',
	'Tirhuta',
	'Todhri',
	'Toto',
	'Ugaritic',
	'Unknown',
	'Vai',
	'Vithkuqi',
	'Wancho',
	'Warang_Citi',
	'Yezidi',
	'Yi',
	'Zanabazar_Square'
];

const supportedScripts = unicodeScripts.filter(s => {
	try {
		new RegExp(`\\p{Script=${s}}`, 'u');
		return true;
	} catch (_e) {
		return false;
	}
});

export const isIntlDiff = (base: string, intl: string): boolean => {
	if (!base || !intl) return false;
	const getFirstLetter = (s: string) => s.match(/\p{L}/u)?.[0];

	const charA = getFirstLetter(base);
	const charB = getFirstLetter(intl);

	if (!charA || !charB) return false;

	const identify = (char: string) =>
		supportedScripts.find(s => new RegExp(`\\p{Script=${s}}`, 'u').test(char));

	const scriptA = identify(charA);
	const scriptB = identify(charB);

	if (!scriptA || !scriptB) return false;

	return scriptA !== scriptB;
};

export const returnValidIntl = (
	base: string | null | undefined,
	intl: string | null | undefined
) => (isIntlDiff(base ?? '', intl ?? '') ? intl : undefined);
